import { type Mesh } from '@/gfx/mesh';

export const createBoxMesh = (sizeX: number, sizeY: number, sizeZ: number): Mesh => {
  const x = sizeX * 0.5;
  const y = sizeY * 0.5;
  const z = sizeZ * 0.5;

  // 6 faces × 4 unique vertices = 24 verts, flat normals, CCW winding from outside.
  // prettier-ignore
  const positions = new Float32Array([
    +x, -y, +z,  +x, -y, -z,  +x, +y, -z,  +x, +y, +z, // +X
    -x, -y, -z,  -x, -y, +z,  -x, +y, +z,  -x, +y, -z, // -X
    -x, +y, +z,  +x, +y, +z,  +x, +y, -z,  -x, +y, -z, // +Y
    -x, -y, -z,  +x, -y, -z,  +x, -y, +z,  -x, -y, +z, // -Y
    -x, -y, +z,  +x, -y, +z,  +x, +y, +z,  -x, +y, +z, // +Z
    +x, -y, -z,  -x, -y, -z,  -x, +y, -z,  +x, +y, -z, // -Z
  ]);

  // prettier-ignore
  const normals = new Float32Array([
     1, 0, 0,   1, 0, 0,   1, 0, 0,   1, 0, 0,
    -1, 0, 0,  -1, 0, 0,  -1, 0, 0,  -1, 0, 0,
     0, 1, 0,   0, 1, 0,   0, 1, 0,   0, 1, 0,
     0,-1, 0,   0,-1, 0,   0,-1, 0,   0,-1, 0,
     0, 0, 1,   0, 0, 1,   0, 0, 1,   0, 0, 1,
     0, 0,-1,   0, 0,-1,   0, 0,-1,   0, 0,-1,
  ]);

  // Each face gets a full [0,1] UV square in tile-local space.
  // Quad winding for each face is (BL, BR, TR, TL) when viewed from outside.
  // prettier-ignore
  const uvs = new Float32Array([
    0, 1,  1, 1,  1, 0,  0, 0, // +X
    0, 1,  1, 1,  1, 0,  0, 0, // -X
    0, 1,  1, 1,  1, 0,  0, 0, // +Y
    0, 1,  1, 1,  1, 0,  0, 0, // -Y
    0, 1,  1, 1,  1, 0,  0, 0, // +Z
    0, 1,  1, 1,  1, 0,  0, 0, // -Z
  ]);

  const indices = new Uint16Array(36);
  for (let face = 0; face < 6; face++) {
    const i = face * 6;
    const v = face * 4;
    indices[i + 0] = v + 0;
    indices[i + 1] = v + 1;
    indices[i + 2] = v + 2;
    indices[i + 3] = v + 0;
    indices[i + 4] = v + 2;
    indices[i + 5] = v + 3;
  }

  return { positions, normals, uvs, indices };
};
